"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupToggle = GroupToggle;
exports.RowMenu = RowMenu;
const jsx_runtime_1 = require("react/jsx-runtime");
const button_1 = require("./button");
const dropdown_menu_1 = require("./dropdown-menu");
const icon_1 = require("./icon");
/* 30 Oct 2026 · the two per-row controls the table and the card both draw. */
/**
 * 30 Oct 2026 · a group row's chevron. ⚠️ **No `data-stop`**: its click is the row's click, so the
 * row toggles once whether the reader hit the chevron or the name — the button is here to be
 * focusable and to say `aria-expanded`, not to be a second handler.
 */
function GroupToggle({ group }) {
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", "aria-expanded": group.expanded, "aria-label": group.label, className: "text-muted-foreground hover:text-foreground focus-visible:ring-ring/50 -my-1 grid size-5 shrink-0 place-items-center rounded-sm outline-none focus-visible:ring-[3px]", children: (0, jsx_runtime_1.jsx)(icon_1.Icon, { name: group.expanded ? 'chevron-down' : 'chevron-right', size: 14 }) }));
}
/**
 * 30 Oct 2026 · ⚠️ **A row with nothing to do draws no kebab** — a menu that opens empty is a
 * control that does nothing. The cell stays, so the columns keep their place.
 */
function RowMenu({ items, label }) {
    if (items.length === 0)
        return null;
    return ((0, jsx_runtime_1.jsx)(dropdown_menu_1.DropdownMenu, { items: items, width: 232, align: "end", label: label, children: (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "ghost", size: "icon-sm", "aria-label": label, children: (0, jsx_runtime_1.jsx)(icon_1.Icon, { name: "ellipsis", size: 15 }) }) }));
}
//# sourceMappingURL=row-controls.js.map